module.exports = __webpack_public_path__ + "static/media/card-ELO.be16b227.svg";